import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/chigua";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-18 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-bard-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-xl md:text-2xl tracking-wide text-foreground-950">吃瓜福利</span>
            <span className="mt-0.5 text-[10px] md:text-xs text-foreground-600">CHIGUA · 今日更新抢先看</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-md px-3 py-2 text-sm text-foreground-800 transition-colors hover:bg-background-200 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs text-accent-700">
            <i className="ri-record-circle-fill text-accent-500 animate-pulse"></i>
            <span className="whitespace-nowrap">实时更新中</span>
          </span>
          <button
            type="button"
            className="flex h-9 items-center gap-2 rounded-full bg-primary-500 px-4 text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            <i className="ri-notification-3-fill"></i>
            订阅快讯
          </button>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-xl text-foreground-900 md:hidden"
          aria-label="打开菜单"
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-200"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <button
            type="button"
            className="mt-2 flex h-9 items-center gap-2 rounded-full bg-primary-500 px-4 text-sm text-background-50 whitespace-nowrap"
          >
            <i className="ri-notification-3-fill"></i>
            订阅快讯
          </button>
        </div>
      )}
    </header>
  );
}